import { render, staticRenderFns } from "./display-text-data.vue?vue&type=template&id=e445e4e6&"
import script from "./display-text-data.vue?vue&type=script&lang=js&"
export * from "./display-text-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports